import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Meta from './views/Meta.vue'
import Project from './views/Project.vue'
import Login from './views/Login.vue'
import {auth} from "./firebase";

// noinspection JSUnresolvedFunction
Vue.use(Router);

const router = new Router({
    mode: "history",
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                auth: true
            }
        },
        {
            path: '/meta',
            name: 'meta',
            component: Meta,
            meta: {
                auth: true
            }
        },
        {
            path: '/project/:key?',
            name: 'project',
            component: Project,
            meta: {
                auth: true
            }
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        }
    ]
});

auth.onAuthStateChanged(user => {
    if (router.currentRoute.meta.auth && !user) {
        router.replace("/login");
    } else if (!router.currentRoute.meta.auth && user) {
        router.replace("/");
    }
});

router.beforeEach((to, from, next) => {
    const user = auth.currentUser;
    if (to.meta.auth && !user) {
        next("/login");
    } else if (!to.meta.auth && user) {
        next("/");
    } else {
        next();
    }
});

export default router;
